<template>
  <TvBase storage-key="tv3id">
    <div v-if="state === 'INTERSTICIEL'" class="view tv dark">
      <IntersticeThree />
    </div>
    <div v-if="state !== 'INTERSTICIEL' && screenData" class="view tv dark">
      <Screen v-if="state === ''" :data="screen1">
        <BarChart :commuters="screen1.data.entries" :colors="screen1.data.colors" />
      </Screen>
      <Screen v-if="state === 'SYNTHESIS'" :data="screen2">
        <TableBlock :data="screen2.data" :index="index" :scrollIndex="scrollIndex" />
        <SensitiveCase />
      </Screen>
      <Screen v-if="state === 'IMPACT' && focus === 'DECAY'" :data="screen3">
        <TableBlock :data="screen3.data" :index="index" :scrollIndex="scrollIndex" />
      </Screen>
      <Screen v-if="state === 'IMPACT' && focus === 'IMRPROVEMENT'" :data="screen5">
        <TableBlock :data="screen5.data" :index="index" :scrollIndex="scrollIndex" />
      </Screen>
      <Screen v-if="state === 'TRANSIT' && distribution === 'LOCALISATION'">
        <TableBlock :data="screen4.data" :index="index" :scrollIndex="scrollIndex" />
      </Screen>
      <Screen v-if="state === 'TRANSIT' && (distribution === 'TIME' || distribution === 'PERCENTAGE')" :data="screen7">
        <!-- <TableBlock :data="screen4.data" :index="index" :scrollIndex="scrollIndex" /> -->
        <CollaboratorsByTransitTimeTable :data="screenData" :advencedMode="graphAdvencedMode" />
      </Screen>
      <!-- <div v-if="state === 'TRANSIT' && (distribution === 'TIME' || distribution === 'PERCENTAGE')">
        <div class="commuter-logo"></div>
      </div> -->
      <Screen v-if="state === 'ENVIRONMENTAL'">
        <div class="commuter-logo"></div>
      </Screen>
      <Screen v-if="state === 'OUTLIER'" :data="screen6">
        <TableBlock :data="screen6.data" :index="index" :scrollIndex="scrollIndex" />
      </Screen>
    </div>
  </TvBase>
</template>

<script>
import CollaboratorsByTransitTimeTable from '@/components/Analysis/Transit/CollaboratorsByTransitTimeTable';
import Tv from './TvMixin';
import { extendedTimeRangesCaptions, timeRangesCaptions } from '@/pure/ComputedData';

export default {
  name: 'Tv3',

  components: {
    CollaboratorsByTransitTimeTable,
  },

  mixins: [Tv],

  data() {
    return {
      state: 'INTERSTICIEL',
      lastState: '',
      focus: 'IMRPROVEMENT',
      distribution: 'LOCALISATION',
      index: -1,
      graphAdvencedMode: false,
      scrollIndex: 0,
      screenData: null,
    };
  },

  computed: {
    screen1() {
      const { collaboratorsByRegion, filteredCollaboratorsCount } = this.screenData;
      const entries = collaboratorsByRegion
        .sort((a, b) => {
          return b.count - a.count;
        })
        .slice(0, 8)
        .map(item => {
          const { caption, count } = item;
          return [caption || this.$t('notProvided'), filteredCollaboratorsCount ? count / filteredCollaboratorsCount : 0];
        });
      return {
        heading: {
          caption: this.$t('collaboratorLocation'),
          icon: 'people',
        },
        data: {
          entries,
          colors: ['#D60808', '#D8D8D8', '#f1e7ca', '#8b8181', '#9a054a', '#602376', '#7874b5', '#ed700a'],
        },
      };
    },

    screen2() {
      const entries = this.comuputesensibleCaseDecay();
      return {
        heading: {
          caption: this.$t('sections.outlier'),
          icon: 'alert',
        },
        data: {
          entries,
        },
      };
    },

    screen3() {
      const { sites, useExtendedTimeRanges } = this.screenData;
      const headerCaption = useExtendedTimeRanges ? extendedTimeRangesCaptions : timeRangesCaptions;
      const entries = sites.map(site => {
        const { decayedCollaboratorsTimesByTimeRanges } = site.details;
        return decayedCollaboratorsTimesByTimeRanges.map(item => {
          return {
            value: item.count,
          };
        });
      });
      return {
        heading: {
          caption: this.$t('report.impactFocus'),
          icon: 'sad',
        },
        data: {
          specifications: headerCaption.map(caption => {
            return {
              type: 'heading',
              caption,
              icon: 'up',
            };
          }),
          entries,
        },
      };
    },

    screen5() {
      const { sites, useExtendedTimeRanges } = this.screenData;
      const headerCaption = useExtendedTimeRanges ? extendedTimeRangesCaptions : timeRangesCaptions;
      const entries = sites.map(site =>
        site.details.improvedCollaboratorsTimesByTimeRanges.map(item => {
          return {
            value: item.count,
          };
        }),
      );

      return {
        heading: {
          caption: this.$t('report.impactFocusImprovement'),
          icon: 'happy',
        },
        data: {
          specifications: headerCaption.map(caption => {
            return {
              type: 'heading',
              caption,
              icon: 'down',
            };
          }),
          entries,
        },
      };
    },

    screen4() {
      const { collaboratorsByRegion, sites } = this.screenData;
      const subHeaderCaption = this.$t('CurrentSiteName');
      const subHeader = {
        type: 'sub-header',
        caption: subHeaderCaption,
      };
      const superHeader = [subHeader];

      const specifications = [subHeader];
      collaboratorsByRegion.slice(4, 8).forEach(region => {
        superHeader.push({
          caption: region.caption,
          value: region.percentage,
          sub: '%',
        });
        specifications.push({
          value: region.averageTime,
          sub: ' min',
        });
      });
      const entries = sites.map(site => {
        const result = [subHeader];
        site.details.collaboratorsByRegion
          .slice(4, 8)
          .forEach((item, idx) => result.push(this.computeTrend(item.averageTime - collaboratorsByRegion[idx + 4].averageTime)));
        return result;
      });

      const data = {
        superHeader,
        specifications,
        entries,
      };
      return {
        data,
      };
    },

    screen6() {
      const { sites } = this.screenData;
      const headerCaption = ['20 - 25 min', '25 - 30 min', '+ 30 min'];
      const entries = sites.map(site => {
        const { sensibleCaseCollaboratorsByTimeDiffRanges } = site.details;
        return sensibleCaseCollaboratorsByTimeDiffRanges.map(item => {
          return {
            value: item.count,
          };
        });
      });
      return {
        heading: {
          caption: this.$t('distributionByAccesTime'),
          icon: 'alert',
        },
        data: {
          specifications: headerCaption.map(caption => {
            return {
              type: 'heading',
              caption,
              icon: 'up',
            };
          }),
          entries,
        },
      };
    },

    screen7() {
      let values = this.screenData.sites.map(e => ({
        site: e.name,
        r010: e.details.collaboratorsByTimeRanges[0].count,
        r1120: e.details.collaboratorsByTimeRanges[1].count,
        r2130: e.details.collaboratorsByTimeRanges[2].count,
        r3140: e.details.collaboratorsByTimeRanges[3].count,
        r4150: e.details.collaboratorsByTimeRanges[4].count,
        r5160: e.details.collaboratorsByTimeRanges[5].count,

        r030: e.details.collaboratorsByTimeRanges[0].count + e.details.collaboratorsByTimeRanges[1].count + e.details.collaboratorsByTimeRanges[2].count,
        r3160: e.details.collaboratorsByTimeRanges[3].count + e.details.collaboratorsByTimeRanges[4].count + e.details.collaboratorsByTimeRanges[5].count,
        r60: e.details.collaboratorsByTimeRanges[6].count,

        t45:
          e.details.collaboratorsByTimeRanges[0].count +
          e.details.collaboratorsByTimeRanges[1].count +
          e.details.collaboratorsByTimeRanges[2].count +
          e.details.collaboratorsByTimeRanges[3].count +
          (e.details.collaboratorsByTimeRanges[4].count * (e.details.collaboratorsByTimeRanges[4].averageTime - 40)) / 10,
        total:
          e.details.collaboratorsByTimeRanges[0].count +
          e.details.collaboratorsByTimeRanges[1].count +
          e.details.collaboratorsByTimeRanges[2].count +
          e.details.collaboratorsByTimeRanges[3].count +
          e.details.collaboratorsByTimeRanges[4].count +
          e.details.collaboratorsByTimeRanges[5].count +
          e.details.collaboratorsByTimeRanges[6].count,
      }));

      values.unshift({
        site: this.$t('actualSites', this.screenData.actualSites.length),
        r010: this.screenData.collaboratorsByTimeRanges[0].count,
        r1120: this.screenData.collaboratorsByTimeRanges[1].count,
        r2130: this.screenData.collaboratorsByTimeRanges[2].count,
        r3140: this.screenData.collaboratorsByTimeRanges[3].count,
        r4150: this.screenData.collaboratorsByTimeRanges[4].count,
        r5160: this.screenData.collaboratorsByTimeRanges[5].count,

        r030:
          this.screenData.collaboratorsByTimeRanges[0].count +
          this.screenData.collaboratorsByTimeRanges[1].count +
          this.screenData.collaboratorsByTimeRanges[2].count,
        r3160:
          this.screenData.collaboratorsByTimeRanges[3].count +
          this.screenData.collaboratorsByTimeRanges[4].count +
          this.screenData.collaboratorsByTimeRanges[5].count,
        r60: this.screenData.collaboratorsByTimeRanges[6].count,

        t45:
          this.screenData.collaboratorsByTimeRanges[0].count +
          this.screenData.collaboratorsByTimeRanges[1].count +
          this.screenData.collaboratorsByTimeRanges[2].count +
          this.screenData.collaboratorsByTimeRanges[3].count +
          (this.screenData.collaboratorsByTimeRanges[4].count * (this.screenData.collaboratorsByTimeRanges[4].averageTime - 40)) / 10,
        total:
          this.screenData.collaboratorsByTimeRanges[0].count +
          this.screenData.collaboratorsByTimeRanges[1].count +
          this.screenData.collaboratorsByTimeRanges[2].count +
          this.screenData.collaboratorsByTimeRanges[3].count +
          this.screenData.collaboratorsByTimeRanges[4].count +
          this.screenData.collaboratorsByTimeRanges[5].count +
          this.screenData.collaboratorsByTimeRanges[6].count,
      });

      return {
        heading: {
          caption: this.$t('collaboratorsByAccessTime'),
          icon: 'clock',
        },
        data: {
          entries: values,
          advencedMode: true,
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.commuter-logo {
  width: 768px;
  height: 384px;
  margin: 256px auto 0;
  opacity: 0.4;
  background-image: url('./../../assets/CommuterLogo-White.svg');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
}
</style>
